import { PLAN_TYPES, PLAN_TYPES_RANGED } from 'containers/App/constants'

export const getPlanName = (planValue) =>
  Object.keys(PLAN_TYPES).find((key) => PLAN_TYPES[key] === planValue) || 'N/A'

export const exactCampaignsOnlyPlan = (plan) => plan === PLAN_TYPES.CAMPAIGNS_ONLY
export const exactStarterPlan = (plan) => plan === PLAN_TYPES.STARTER
export const exactCorePlan = (plan) => plan === PLAN_TYPES.CORE
export const exactIronscalesProtectPlan = (plan) => plan === PLAN_TYPES.IRONSCALES_PROTECT
export const exactEmailProtectPlan = (plan) => plan === PLAN_TYPES.EMAIL_PROTECT
export const exactCompleteProtectPlan = (plan) => plan === PLAN_TYPES.COMPLETE_PROTECT

export const isSimulationAndTraining = (plan) => [PLAN_TYPES.SAT_SUITE, PLAN_TYPES.CAMPAIGNS_ONLY].includes(plan)

export const atLeastCampaignsOnlyPlan = (plan) =>
  PLAN_TYPES_RANGED[plan] >= PLAN_TYPES_RANGED[PLAN_TYPES.CAMPAIGNS_ONLY]
export const atLeastStarterPlan = (plan) =>
  PLAN_TYPES_RANGED[plan] >= PLAN_TYPES_RANGED[PLAN_TYPES.STARTER]
export const atLeastIronscalesProtectPlan = (plan) =>
  PLAN_TYPES_RANGED[plan] >= PLAN_TYPES_RANGED[PLAN_TYPES.IRONSCALES_PROTECT]
export const atLeastCorePlan = (plan) =>
  PLAN_TYPES_RANGED[plan] >= PLAN_TYPES_RANGED[PLAN_TYPES.CORE]
export const atLeastEmailProtectPlan = (plan) =>
  PLAN_TYPES_RANGED[plan] >= PLAN_TYPES_RANGED[PLAN_TYPES.EMAIL_PROTECT]
// Does not make sense since there is nothing above this plan for now
// export const atLeastCompleteProtectPlan = (plan) => plan >= PLAN_TYPES.COMPLETE_PROTECT

export const mapPlanNameByStatus = {
  [PLAN_TYPES.CAMPAIGNS_ONLY]: 'Simulation & Training',
  [PLAN_TYPES.SAT_SUITE]: 'SAT Suite',
  [PLAN_TYPES.STARTER]: 'Starter',
  [PLAN_TYPES.CORE]: 'Essential Protect (Core)',
  [PLAN_TYPES.IRONSCALES_PROTECT]: 'IRONSCALES Protect',
  [PLAN_TYPES.EMAIL_PROTECT]: 'Email Protect',
  [PLAN_TYPES.COMPLETE_PROTECT]: 'Complete Protect',
}
